import axios from "axios";

const BASE_URL = `/m-1/shop`;

/**
 * Serwis do komunikacji z API - endpoint /shop
 */
export const StoreService = {
  storeOrder,
  storeExclusiveOrder,
  getOrder,
  storeItems,
  checkLinkIsActive,
  updateClientFundingOrder,
};

function storeOrder(clientId, data) {
  return axios.post(`${BASE_URL}/order/${clientId}`, data);
}

function storeExclusiveOrder(clientId, data) {
  return axios.put(`${BASE_URL}/order/exclusive-offer/${clientId}`, data);
}

function updateClientFundingOrder(clientId, data) {
  return axios.put(`${BASE_URL}/order/funding/${clientId}`, data);
}

function getOrder(clientId, data) {
  return axios.get(`${BASE_URL}/order/${clientId}`, data);
}

function storeItems() {
  return axios.get(`${BASE_URL}/items`);
}

function checkLinkIsActive(uuidLink) {
  return axios.post(`${BASE_URL}/exclusive-link/is-active/${uuidLink}`);
}
